export default {
    root: {
        gap: '0.25rem',
        transitionDuration: '{transition.duration}'
    },
    icon: {
        size: '1rem',
        color: '{text.muted.color}',
        hoverColor: '{primary.color}',
        activeColor: '{primary.color}'
    }
};
